var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46671 12.0851L9.4117 9.14023H1.7136C0.767203 9.14023 0 9.90739 0 10.8539V11.5548C0 11.9907 0.135938 12.4158 0.388886 12.7708C1.44634 14.2549 3.10897 15.065 5.33083 15.2124C5.3277 15.0731 5.34309 14.9298 5.37936 14.7847L5.72812 13.3897C5.85157 12.896 6.10683 12.445 6.46671 12.0851ZM6.09319 0C8.19733 0 9.90311 1.70576 9.90311 3.80992C9.90311 5.91408 8.19733 7.61985 6.09319 7.61985C3.989 7.61985 2.28324 5.91408 2.28324 3.80992C2.28324 1.70576 3.989 0 6.09319 0ZM11.5029 8.12626L7.00528 12.6238C6.74309 12.886 6.55709 13.2146 6.4671 13.5744L6.11834 14.9693C5.9667 15.5759 6.51624 16.1255 7.12286 15.9738L8.51782 15.625C8.87755 15.5351 9.20612 15.3491 9.46839 15.0868L13.9659 10.5893C14.6461 9.90915 14.6461 8.80641 13.9659 8.12626C13.2858 7.44604 12.183 7.44604 11.5029 8.12626Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.535d8034d582a31f98bde1c86c333458.svg";
export { ForwardRef as ReactComponent };